import "../style/ProductsQuickView.css";
import { memo } from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { Heart } from "lucide-react";
import { Player } from "@lottiefiles/react-lottie-player";
import heartAnimation from "../../../../assets/icons/Heart.json";
import { LocationTick } from "iconsax-react";
import LoginPromptModal from "../../../../components/LoginModal/LoginPromptModal";
import ProductQuickViewGallery from "../components/ProductQuickViewGallery";
import PriceDetail from "../components/PriceDetail";
import Tracksku from "../components/Tracksku";
import ColorSelect from "../components/colorSelect";
import QuantitySelect from "../components/QuantitySection";
import PinCode from "../components/PinCode";
import SizeSelectBox from "../components/SizeSelectBox";
import AddCartSection from "../components/AddToCartButton";
import ReturnDetails from "../components/ReturnDetails";
import useQuickView from "../hook/useQuickViewContent";

const ProductQuickViewModal = ({ show, product, onHide }) => {
  const quickView = useQuickView({ product, show, onHide });
  if (!show || !product) return null;

  const {
    modalRef,
    imageRef,
    loading,
    localLoading,
    collection,
    selectedMedia,
    setSelectedMedia,
    selectedColor,
    setSelectedColor,
    selectedSize,
    setSelectedSize,
    quantity,
    setQuantity,
    currentPrice,
    productDetails,
    unit,
    setUnit,
    pincode,
    setPincode,
    pincodeDetails,
    pinloading,
    pinerror,
    isPincodeLocked,
    handleMouseMove,
    handleMouseLeave,
    handleOutsideClick,
    handleClose,
    handleCheck,
    handleReset,
    handleAddToCart,
    toggleWishlist,
    selectionColor,
    sizeSelection,
    showLoginPrompt,
  } = quickView;

  return (
    <>
      {/* Overlay */}
      <div className="quickview-modal-overlay" onClick={handleOutsideClick} >
        {/* Modal */}
        <div
          className="quickview-modal"
          ref={modalRef}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="close-icon" onClick={handleClose} style={{ zIndex: "111" }}> <i class="bi bi-x"></i> </div>
          <div className="quickview-modal-box">
            <div className="quickview-header">
              {/* <div /> */}
            </div>
            {/* Content */}
            <div className="product-page">
              {/* LEFT */}
             <ProductQuickViewGallery
                  selectedMedia={selectedMedia}
                  setSelectedMedia={setSelectedMedia}
                  selectedColor={selectedColor}
                  selectedSize={selectedSize}
                  productDetails={productDetails}
                  handleMouseMove={handleMouseMove}
                  handleMouseLeave={handleMouseLeave}
                  loading={loading}
                  Skeleton={Skeleton}
                  imageRef={imageRef}
                  localLoading={localLoading}
                />
              {/* RIGHT */}
              <div className="product-info" style={{ padding: "0px 20px 20px 20px" }}>
                <p className="product-collection" style={{ marginBottom: "0 " }}>
                  {loading ? <Skeleton width={120} /> : collection}
                </p>

                <h1 className="title_details">
                  {loading ? <Skeleton width={200} /> : selectedSize?.name}
                </h1>

                <PriceDetail
                  loading={loading}
                  Skeleton={Skeleton}
                  currentPrice={currentPrice}
                  selectedSize={selectedSize}
                  sizeSelection={sizeSelection}
                />

                <Tracksku
                  loading={loading}
                  Skeleton={Skeleton}
                  selectedSize={selectedSize}
                />

                {/* <SizeSelectBox
                  localLoading={localLoading}
                  Skeleton={Skeleton}
                  productDetails={productDetails}
                  selectedSize={selectedSize}
                  unit={unit}
                  setUnit={setUnit}
                  setSelectedSize={setSelectedSize}
                  sizeSelection={sizeSelection}
                /> */}

                <SizeSelectBox
                  localLoading={localLoading}
                  Skeleton={Skeleton}
                  productDetails={productDetails}
                  selectedSize={selectedSize}
                  unit={unit}
                  setUnit={setUnit}
                  setSelectedSize={setSelectedSize}
                  setSelectedColor={setSelectedColor}
                  sizeSelection={sizeSelection}
                />

                <ColorSelect
                  loading={loading}
                  Skeleton={Skeleton}
                  selectedColor={selectedColor}
                  selectedSize={selectedSize}
                  setSelectedColor={setSelectedColor}
                  setSelectedMedia={setSelectedMedia}
                  selectionColor={selectionColor}
                />

                <QuantitySelect
                  loading={loading}
                  Skeleton={Skeleton}
                  quantity={quantity}
                  setQuantity={setQuantity}
                />

                <PinCode
                  loading={loading}
                  pincode={pincode}
                  setPincode={setPincode}
                  isPincodeLocked={isPincodeLocked}
                  handleCheck={handleCheck}
                  handleReset={handleReset}
                  pinloading={pinloading}
                  pinerror={pinerror}
                  pincodeDetails={pincodeDetails}
                  Skeleton={Skeleton}
                  LocationTick={LocationTick}
                />

                <AddCartSection
                  loading={loading}
                  Skeleton={Skeleton}
                  handleAddToCart={handleAddToCart}
                  toggleWishlist={toggleWishlist}
                  selectedSize={selectedSize}
                  Player={Player}
                  heartAnimation={heartAnimation}
                  Heart={Heart}
                />

                <ReturnDetails
                  loading={loading}
                  Skeleton={Skeleton}
                  productDetails={productDetails}
                  Link={Link}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {showLoginPrompt && (
        <LoginPromptModal onClose={handleClose} />
      )}
    </>
  );
};
export default memo(ProductQuickViewModal);